// Package Imports
import { ArrowLeftOutlined } from '@ant-design/icons';
// prettier-ignore
import {BaseRecord,useCreate,useDelete,useNavigation,useTable,
  useTranslate,
  useUpdate,
} from '@refinedev/core';
import { Button, Card, Flex, Typography, Form } from 'antd';
// Project Imports
import { useRulesContext } from 'contexts/rulesContext/RulesContext';
import apiEndpoint from 'core/common/apiEndPoints';
import replacePipe from 'core/utils/replacePipe';
import { useEffect, useState } from 'react';
import useLogger from 'core/utils/useLogger';
import RulePlansCreate from 'pages/rulePlans/RulePlansCreate';
import resourceName from 'core/common/resourceName';
import openNotificationWithIcon from 'core/utils/notification';
import constants from 'core/constants/Constants';
import Loading from 'components/loading/loading';
import GroupRuleList from 'pages/rules/groupRuleList';
import RuleViewModal from 'pages/rules/ruleViewModal';

const RuleView = ({ pageType }) => {
  const { Title } = Typography;
  const { list } = useNavigation();
  const t = useTranslate();
  const { rulePlanDataObj, refetchRuleDetails } = useRulesContext();
  const [rulesDetails, setRuleDetails] = useState<any>();
  const [toggle, setToogle] = useState(false);
  const [activeType, setActiveType] = useState('group');
  const [activePageType, setActivePageType] = useState('Create');
  const [id, setId] = useState(undefined);
  const [reArrangeModalOpen, setReArrangeModalOpen] = useState(false);
  const [ruleGroupList, setRuleGroupList] = useState([]);
  const [isFilterModalVisible, setIsFilterModalVisible] = useState(false);
  const [filterListVals, setFilterSelectVals] = useState({});
  const [, setFilterQueryString] = useState('');
  const [tempRuleGroupList, setTempRuleGroupList] = useState<any[]>([]);
  const [copyModalVisible, setCopyModalVisible] = useState(false);
  const [copyModalRow, setCopyModalRow] = useState<any>(null);
  const [isCopyModalSubmitDisabled, setIsCopyModalSubmitDisabled] =
    useState(true);
  const [copyModalForm] = Form.useForm();

  const handleFetchfilters = () => {
    if (Object.keys(filterListVals)?.length > 0) {
      const result = Object.entries(filterListVals)
        .filter(([, value]) => Array.isArray(value))
        .flatMap(([, value]) =>
          // Using type assertion for TypeScript
          (value as any[]).map((item) => String(item).replace(/\s+/g, ''))
        );
      return `/?rule_filter=${result.join('~')}`;
    }
    return ''; // Empty string when no filters
  };
  const { tableQueryResult: ruleDetailsQueryList } = useTable({
    resource: `${pageType === 'Show' && rulePlanDataObj?.view_unique_id ? `${apiEndpoint.rulesPlan}/${rulePlanDataObj?.view_unique_id}` : `${apiEndpoint.rulesPlanDraft}/${rulePlanDataObj?.edit_unique_id}`}`,
    queryOptions: {
      enabled: !!rulePlanDataObj?.unique_id,
    },
    pagination: {
      mode: 'off',
    },
    successNotification: () => {
      setToogle(!toggle);
      return null;
    },
    errorNotification: (data: BaseRecord) => {
      const message =
        replacePipe(data?.message) || t('notifications.errorMessage');
      return {
        message: 'Error Message',
        description: message,
        type: 'error',
      };
    },
  });
  const { refetch: ruleDetailsRefetch } = ruleDetailsQueryList;
  const rulesData = (ruleDetailsQueryList?.data?.data as BaseRecord)?.results;
  const logger = useLogger();
  const { mutate: deleteRuleAndRuleGroup, isLoading } = useDelete();
  const filterList = rulesData?.filter_list;
  useEffect(() => {
    if (rulesData) {
      const updatedRuleGroupList = rulesData.rule_group_list.map(
        (groupItem) => ({ ...groupItem, expanded: true })
      );
      setRuleDetails({
        ...rulesData,
        rule_group_list: updatedRuleGroupList,
      });
    }
  }, [toggle]);

  const fetchData = async () => {
    try {
      await ruleDetailsRefetch();
      setId(undefined);
      setActiveType('group');
      setActivePageType('Create');
    } catch (error) {
      logger('Error fetching data:', error);
    }
  };

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    fetchData();
  }, [refetchRuleDetails]);
  useEffect(() => {
    if (rulesDetails?.rule_group_list?.length > 0) {
      setRuleGroupList(rulesDetails?.rule_group_list);
    } else {
      setRuleGroupList([]);
    }
  }, [rulesDetails]);
  function goToList() {
    list(resourceName.rulePlans);
  }
  const { mutate: CreateMutate } = useCreate();
  const handleCopyRulePlan = async () => {
    try {
      const values = await copyModalForm.validateFields();
      CreateMutate(
        {
          resource: `${apiEndpoint.copyRule}`,
          values: {
            rule_name: values?.rule_name,
            rule_unique_id: copyModalRow?.unique_id,
            rule_group_id: values?.rule_group_id,
          },
          successNotification: false,
          errorNotification: false,
        },
        {
          onSuccess: async (data) => {
            setCopyModalVisible(false);
            setCopyModalRow(null);

            copyModalForm.resetFields();
            setIsCopyModalSubmitDisabled(true);
            const message =
              data?.data?.message || t('notifications.createSuccess');
            openNotificationWithIcon(
              constants.success,
              t('notifications.mutationSuccess'),
              message
            );
            await fetchData();
          },
          onError(error) {
            const message = error?.message || t('notifications.somethingError');
            openNotificationWithIcon(
              constants.error,
              t('notifications.mutationError'),
              message
            );
          },
        }
      );
    } catch (err) {
      // Validation error, do nothing
    }
  };
  const { mutate } = useUpdate();
  const onReArrangeroupRuleGroup = async () => {
    // Update the actual state with the temporary list
    setRuleDetails({ ...rulesDetails, rule_group_list: tempRuleGroupList });

    mutate(
      {
        resource: `${pageType === 'Show' && rulePlanDataObj?.view_unique_id ? apiEndpoint.ruleGroup : apiEndpoint.ruleGroupDraft}`,
        values: tempRuleGroupList,
        id: tempRuleGroupList?.[0]?.unique_id,
        successNotification: false,
        errorNotification: false,
      },
      {
        onSuccess: (data) => {
          const message =
            data?.data?.message || t('notifications.createSuccess');
          openNotificationWithIcon(
            constants.success,
            t('notifications.mutationSuccess'),
            message
          );
          setReArrangeModalOpen(false);
        },
        onError(error) {
          const message = error?.message || t('notifications.somethingError');
          openNotificationWithIcon(
            constants.error,
            t('notifications.mutationError'),
            message
          );
        },
      }
    );
  };
  const handleCancel = () => {
    // Reset the temporary list and close modal
    setTempRuleGroupList([]);
    setReArrangeModalOpen(false);
  };
  const handleCloseFilterModal = () => {
    setFilterSelectVals({});
    setIsFilterModalVisible(false);
  };
  const handleReset = () => {
    const queryString = '';
    setFilterQueryString(queryString);
    setIsFilterModalVisible(false);
    setFilterSelectVals({});
  };
  function toggleFilter(value, filterName) {
    const filterLists = { ...filterListVals };
    if (!filterLists[filterName]) {
      filterLists[filterName] = [];
    }
    const exists = filterLists[filterName].includes(value);
    if (exists) {
      filterLists[filterName] = filterLists[filterName].filter(
        (item) => item !== value
      );
    } else {
      filterLists[filterName].push(value);
    }
    setFilterSelectVals(filterLists);
  }
  const handleSubmitFilters = async () => {
    const queryString = handleFetchfilters();
    setFilterQueryString(queryString.replaceAll(',', '~'));
    setIsFilterModalVisible(false);
  };
  // Helper to check if the form is valid for enabling submit
  const checkCopyModalFormValid = (values) => {
    const nameValid = !!values.rule_name && values.rule_name.trim() !== '';
    const groupValid =
      !!values.rule_group_id && values.rule_group_id.trim() !== '';
    return nameValid && groupValid;
  };
  const ruleGroupListBasedOnType = ruleGroupList?.filter(
    (item) => item?.rule_type === copyModalRow?.rule_group_details?.rule_type
  );
  if (isLoading) {
    return <Loading />;
  }
  return (
    <>
      <Card className="custom-header mb-md">
        <Flex align="center">
          <Button
            type="text"
            className="mr-md flex justify-center items-center"
            icon={<ArrowLeftOutlined />}
            onClick={goToList}
          />
          <Title className="text-neutral-10 !my-sm" level={4}>
            {t('rules.ruleDetails')}
          </Title>
        </Flex>
      </Card>
      <Card>
        <RulePlansCreate type={pageType} refetch={() => fetchData()} />
        <GroupRuleList
          // prettier-ignore
          stateData=  {{pageType,rulePlanDataObj,rulesDetails,ruleGroupList,id,rulesData,activeType,activePageType}}
          // prettier-ignore
          stateFunctionHandler= {{setCopyModalRow,setCopyModalVisible,setIsCopyModalSubmitDisabled,setIsFilterModalVisible,setTempRuleGroupList,setReArrangeModalOpen,setRuleDetails,setActiveType,setActivePageType,setRuleGroupList,setId}}
          functionHandler={{ deleteRuleAndRuleGroup, fetchData }}
          formData={{ copyModalForm }}
        />
      </Card>
      <RuleViewModal
        // prettier-ignore
        stateData=   {{reArrangeModalOpen,isFilterModalVisible,filterList,filterListVals,copyModalVisible,isCopyModalSubmitDisabled,ruleGroupListBasedOnType}}
        stateFunctionHandler={{
          setCopyModalVisible,
          setCopyModalRow,
          setIsCopyModalSubmitDisabled,
        }}
        // prettier-ignore
        functionHandler={{onReArrangeroupRuleGroup,handleCancel,handleCloseFilterModal,handleSubmitFilters,handleReset,toggleFilter,handleCopyRulePlan,checkCopyModalFormValid}}
        formData={{ copyModalForm }}
      />
    </>
  );
};
export default RuleView;
